////////////////////////////////////////////
// FOOTER — LIVE LAUNCH COUNT + TICKING CLOCK + LOGIN SLOT (PORT OF chrome.js)
////////////////////////////////////////////
//
// "live · N launches · login · time" WITH APP-WIDE LEGAL LINKS. THE COUNT
// POLLS THE LAUNCHES LIST (20s, SHARED QUERY CACHE); THE CLOCK TICKS EVERY
// SECOND; THE LOGIN SLOT SWAPS BETWEEN A LOGIN LINK AND ALIAS/LOGOUT.
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useNetwork } from "@/config/useNetwork";
import { useLaunches } from "@/lib/api/launches";
import { useAuth, useRole } from "@/app/providers/AuthProvider";
import { shortAddr } from "@/lib/format";

export function Footer() {

  const net = useNetwork();
  const launches = useLaunches(String(net.activeNet));
  const { logout } = useAuth();
  const { role, wallet, alias } = useRole();

  // CLOCK — RE-RENDER EVERY SECOND
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {

    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const count = launches.data?.launches?.length ?? null;
  const signedIn = role !== "everybody" && wallet;

  return (
    <div className="text-dim text-[11px] text-center mt-2 font-mono">
      <span className="inline-block w-[7px] h-[7px] rounded-full bg-green-bright mr-[6px] animate-pulse-soft" />
      <span>live · </span>
      <span>{count === null ? "…" : count}</span>
      <span> launches · </span>
      {signedIn ? (
        <a href="#" title="log out" className="text-dim hover:text-fg hover:underline"
          onClick={(e) => { e.preventDefault(); logout(); }}>
          {alias || shortAddr(wallet) || "account"}
        </a>
      ) : (
        <Link to={"/login" + net.navQuery} title="sign in" className="text-dim hover:text-fg hover:underline">login</Link>
      )}
      <span> · </span>
      <span>{now.toLocaleTimeString()}</span>
      <span className="block mt-[6px]">
        {/* PLAIN <a> ON PURPOSE — /guides IS STATIC HTML OUTSIDE THE SPA
            ROUTER, AND THIS APP-WIDE LINK IS WHAT DE-ORPHANS THE SEO PAGES
            (SITEMAP-ONLY DISCOVERY INDEXES SLOWLY; GROWTH.md §2) */}
        <a className="text-dim hover:text-fg hover:underline" href="/guides/">guides</a> ·{" "}
        <Link className="text-dim hover:text-fg hover:underline" to="/legal#terms">terms</Link> ·{" "}
        <Link className="text-dim hover:text-fg hover:underline" to="/legal#privacy">privacy</Link> ·{" "}
        <Link className="text-dim hover:text-fg hover:underline" to="/legal#risk">risk</Link>
      </span>
    </div>
  );
}
